<script lang="ts">
  import { RESERVE_MAX, drainBill, netDrainPerSecond } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import SurgeHandle from "./SurgeHandle.svelte";
  import PowerPanel from "./PowerPanel.svelte";

  const snap = $derived(ship.snap!);
</script>

<div class="console">
  <h3>REACTOR CONTROL</h3>
  <div class="block">
    <h3>RESERVE</h3>
    <meter min="0" max={RESERVE_MAX} low="25" high="60" optimum="100" value={snap.reserve} aria-label="Reactor reserve"></meter>
    <p>{snap.reserve.toFixed(1)} % · NET −{netDrainPerSecond(snap.drainMultiplier).toFixed(2)} %/s, ITEMIZED:</p>
    <ul class="bill">
      {#each drainBill({ cooling: snap.power.cooling, breakerTripped: snap.breakers.status !== "idle", coolantLeak: snap.activeEvent === "coolant" }) as row}
        <li><span>{row.label}</span><span class={row.factor.startsWith("×") ? "warn" : "dim"}>{row.factor}</span></li>
      {/each}
    </ul>
  </div>
  <PowerPanel />
  {#if snap.activeEvent === "coolant"}
    <div class="block leak">
      <h3>COOLANT LOOP 2 — BYPASS VALVE A</h3>
      <p class="warn">LEAK ACTIVE. VALVE B IS IN THE BREAKER BAY. BOTH MUST BE HELD UNTIL SEALED.</p>
      <SurgeHandle task="coolant" handleId="A" verb="SEALING" />
    </div>
  {/if}
  <div class="block">
    <h3>SURGE DUMP — HANDLE A</h3>
    <SurgeHandle handleId="A" />
  </div>
</div>

<style>
  .console { display: grid; gap: 1rem; }
  .block { border: 1px solid var(--fg-dim); padding: 0.7rem; }
  meter { width: 100%; height: 1.2rem; }
  .bill { list-style: none; margin: 0.3rem 0 0; padding: 0; font-size: 0.85em; }
  .bill li { display: flex; justify-content: space-between; gap: 1rem; }
  .leak { border-color: var(--warn); }
</style>
